import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-news-left-sidebar',
  templateUrl: './news-left-sidebar.component.html',
  styleUrls: ['./news-left-sidebar.component.scss']
})
export class NewsLeftSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
